import React from 'react';
import {
  Button,
  Divider,
  Icon,
  PrimaryButton,
  useTranslation,
} from '@testsigma/atoms';
import tickIcon from '@images/tick.svg';
import { usePrepareMetadataSync } from '../../hooks';
import { DocumentURL } from '@utils/common';

const MetadataSyncScreen: React.FC = () => {
  const { t } = useTranslation();
  const { isConnecting, environment, startSync, handleGoBack } =
    usePrepareMetadataSync();

  return (
    <>
      <div className='flex items-center justify-between h-[60px]'>
        <div className='ml-8 items-center my-4 font-medium text-[18px] text-secondary-unique-600'>
          {t('metadata.connection.label')}
        </div>
        <DocumentURL
          path='/docs/salesforce-testing/metadata-connections/'
          label='add-connection.info.link'
          className='r-5 items-center my-4 text-sm text-primary-1000'
        />
      </div>
      <Divider type='solid' />
      <div>
        <div className='flex my-16 py-3 flex-col items-center justify-center h-full'>
          <div className='text-gray-500 text-center flex flex-col items-center'>
            <img
              src={tickIcon}
              className='empty-illustration'
              alt='Tick Illustration'
            />
          </div>
          <div className='my-[48px] text-secondary-unique-600'>
            {t('salesforce-env-and-org.info', {
              environment: environment,
            })}
          </div>

          <PrimaryButton isDisabled={isConnecting} onClick={() => startSync()}>
            <>
              {isConnecting ? (
                <div className='flex gap-x-1.5 items-center'>
                  <Icon
                    className=' text-base flex animate-spin'
                    name='loader'
                  />
                  {t('start-metadata-sync.label')}
                </div>
              ) : (
                t('start-metadata-sync.label')
              )}
            </>
          </PrimaryButton>
        </div>

        <div className='pb-10 flex flex-col items-center justify-center'>
          <Button type='light' isDisabled={isConnecting} onClick={handleGoBack}>
            {t('common.go-back.label')}
          </Button>
        </div>
      </div>
    </>
  );
};

export { MetadataSyncScreen };
